'use strict';

var styleInject_es = require('../../../../node_modules/style-inject/dist/style-inject.es.js');

var css_248z = ".varta-image__subline {\n  font-size: 14px;\n  margin-top: 1em; }\n";
styleInject_es(css_248z);
